import {
	QUEUE_INIT,
	QUEUE_PLAYER_ADD,
	QUEUE_PLAYER_REMOVE,
} from '../actions/queue';
import apiCall from '@/utils/api';
import qs from 'qs';

const state = { queued_player_ids: [] };

const mutations = {
	[QUEUE_INIT]: (state, payload) => {
		state.queued_player_ids = payload || [];
	},
	[QUEUE_PLAYER_ADD]: (state, payload) => {
		apiCall({
			method: 'POST',
			params: payload,
			url: 'api/v1/room_user/queued_players',
		}).then(() => {
			let players = state.queued_player_ids;
			players.push(payload.player_id);
			state.queued_player_ids = players;
		});
	},
	[QUEUE_PLAYER_REMOVE]: (state, payload) => {
		apiCall({
			method: 'DELETE',
			data: qs.stringify(payload),
			url: 'api/v1/room_user/queued_players/delete',
		}).then(() => {
			state.queued_player_ids = state.queued_player_ids.filter(
				e => e.player_id !== payload.player_id
			);
		});
	},
};

const getters = {};

const actions = {
	[QUEUE_INIT]: ({ commit, rootState }) => {
		apiCall({
			method: 'GET',
			url: 'api/v1/room_user/queued_players',
			params: { room_id: rootState.room.id },
		}).then(response => {
			commit(QUEUE_INIT, response.data.queued_player_ids);
			commit('set_queued_players', response.data.queued_player_ids);
		});
	},
};

export default {
	state,
	mutations,
	getters,
	actions,
};
